import { getUserInfo } from "../../../app/state/appSessionStorage"

// state
export interface IUserOnlineStatus {
  userId: string;
  active: boolean;
  visible: boolean;
}

export interface GroupInit {
  name: string;
  users: string[];
  players: string[];
}

export const groupInitial: GroupInit = {
  name: "",
  users: [],
  players: []
}

export interface IChatUserList {
  role: string;
  name: string;
  userId: string;
  lastMessage?: string;
  notification: string;
}

export interface IChatNotification {
  [receiverId: string]: number;
}

export interface IMessage {
  datetime: Date;
  message: string;
  receiverId: string;
  senderId: string;
}

export interface IChatsUIState {
  connected: boolean;
  socket: any;
  chatHistory: any;
  isLoading: boolean;
  error: any;
  currentChatId: string;
  chatHistoryPage: number;
  chatHistoryTotalPage: number;
  chatTab: string;
  chatUserList: NormalizedChatUsersData;
  conversionList: IConversationUserList[];
  notification: IChatNotification;
  totalChatCount: number,
  liveMessages: IMessage[];

  newAppointmentCount: number
  chatGroupList: any
  groupConversionList: IGroupConversationUserList[]
  currentGroupId: string
  groupLiveMessages: IMessage[];
  groupChatHistory: any
  groupChatHistoryPage: number;
  groupChatHistoryTotalPage: number;
}

export const IChatUIInit: IChatsUIState = {
  connected: false,
  chatUserList: {
    entities: {
      chatUsersByUserId: {}
    },
    result: []
  },
  conversionList: [],

  notification: {},

  socket: null,
  chatHistory: [],
  isLoading: false,
  error: null,
  currentChatId: "",
  chatHistoryPage: 1,
  chatHistoryTotalPage: 1,
  chatTab: "chat",
  liveMessages: [],
  totalChatCount: 0,
  newAppointmentCount: getUserInfo()?.newAppointmentCount ? getUserInfo().newAppointmentCount : 0,

  chatGroupList: [],
  currentGroupId: "",
  groupConversionList: [],
  groupLiveMessages: [],
  groupChatHistory: [],
  groupChatHistoryPage: 1,
  groupChatHistoryTotalPage: 1
}

export interface IChatsUIAction {
  type: ChatsActionTypes;
  payload: any;
}

export interface IConversation {
  lastMessage: string;
  lastMessageTimestamp: string;
  unreadCount: number;
  userId: string;
}

export interface IConversationUserList {
  name: string;
  role: string;
  lastMessage: string;
  lastMessageTimestamp: string;
  unreadCount: number | null;
  userId: string;
  active: boolean;
  visible: boolean;
}

export interface IGroupMessage {
  "fromId": string,
  "toId": string,
  "text": string,
  "sentDatetime": Date
}

export interface IGroupConversationUserList {
  groupName: string;
  lastMessage: string;
  lastMessageTimestamp: Date;
  unreadCount: number;
  groupId: string;
}

export interface IGroupList {[key: string]: IGroupConversationUserList}

export interface NormalizedChatUser {
  userId: string;
  firstName: string;
  lastName: string;
  preferredName: string;
  title: string;
  role: string;
  email: string;
  visible?: boolean;
  active?: boolean;
}

export interface NormalizedChatUsersData {
  entities: {
    chatUsersByUserId: {
      [id: string]: NormalizedChatUser;
    };
  };
  result: string[];
}

// Actions
export interface IToggleChatTab {
  type: string;
  payload: string;
}

// Action Types
export enum ChatsActionTypes {
  // to-do
  // move appointment from chatProvide
  UPDATE_NEW_APPOINTMENT_COUNT = "@@appointment/UPDATE_NEW_APPOINTMENT_COUNT",
  RESET_NEW_APPOINTMENT_COUNT = "@@appointment/RESET_NEW_APPOINTMENT_COUNT",

  SEND_NEW_MESSAGE = "@@chats/SEND_NEW_MESSAGE",
  RECEIVED_NEW_MESSAGE = "@@chats/RECEIVED_NEW_MESSAGE",

  CHANGE_USER_ONLINE_STATUS = "@@chats/CHANGE_USER_ONLINE_STATUS",

  RESET_CHAT_STATE = "@@chats/RESET_CHAT_STATE",

  RESET_NOTIFICATION = "@@chats/RESET_NOTIFICATION",
  RESET_LIVE_MESSAGE = "@@chats/RESET_LIVE_MESSAGE",

  SET_HISTORY = "@@chats/SET_HISTORY",
  SET_HISTORY_PAGE = "@@chats/SET_HISTORY_PAGE",
  SET_HISTORY_TOTAL_PAGE = "@@chats/SET_HISTORY_TOTAL_PAGE",

  LOAD_MORE = "@@chats/LOAD_MORE",
  LOAD_MORE_SUCCESS = "@@chats/LOAD_MORE_SUCCESS",
  LOAD_MORE_FAILURE = "@@chats/LOAD_MORE_FAILURE",
  SET_SOCKET = "@@chats/SET_SOCKET",
  SET_CONNECTED = "@@chats/SET_CONNECTED",

  CHAT_USER_LIST = "@@chats/CHAT_USER_LIST",
  CHAT_CONVERSION_USER_LIST = "@@chats/CHAT_CONVERSION_USER_LIST",

  TOGGLE_CHAT_TAB = "@@chats/TOGGLE_CHAT_TAB",
  CURRENT_CHAT_ID = "@@chats/CURRENT_CHAT_ID",

  ADD_NEW_USER_TO_CONVERSATION_LIST = "@@chats/ADD_NEW_USER_TO_CONVERSATION_LIST",

  // Group action types

  CHAT_GROUPS_LIST = "@@chats/CHAT_GROUPS_LIST",
  CURRENT_CHAT_GROUP_ID = "@@chats/CURRENT_CHAT_GROUP_ID",
  RESET_GROUP_LIVE_MESSAGE = "@@chats/RESET_GROUP_LIVE_MESSAGE",

  SEND_NEW_GROUP_MESSAGE = "@@chats/SEND_NEW_GROUP_MESSAGE",
  RECEIVED_NEW_GROUP_MESSAGE = "@@chats/RECEIVED_NEW_GROUP_MESSAGE",

  CHAT_CONVERSION_GROUPS_LIST = "@@chats/CHAT_CONVERSION_GROUPS_LIST",
  SET_GROUP_CHAT_HISTORY = "@@chats/SET_GROUP_CHAT_HISTORY",
  SET_GROUP_CHAT_HISTORY_PAGE = "@@chats/SET_GROUP_CHAT_HISTORY_PAGE",
  SET_GROUP_CHAT_HISTORY_TOTAL_PAGE = "@@chats/SET_GROUP_CHAT_HISTORY_TOTAL_PAGE",
  RESET_GROUP_CHAT_NOTIFICATION = "@@chats/RESET_GROUP_CHAT_NOTIFICATION",
}

export const allowedRolesToFetchGroupData = [
  "claim_manager",
  "org_admin",
  "claimant",
  "rehab_manager",
  "employer"
]
